import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

// 1234567.891 -> "1234567,89": no currency, no thousand separators, comma decimal.
export const plainNumber = (value, decimals = 2, trim = false) => {
  const s = Number(value).toFixed(decimals);
  return (trim ? s.replace(/\.?0+$/, '') : s).replace('.', ',');
};

const writeClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = Object.assign(document.createElement('textarea'), { value: text });
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
  }
};

/** Small button that copies a number ready to paste into a calculator or spreadsheet. */
export const CopyNumberButton = ({ value, decimals = 2, trim = false, testId, className = '', size = 'md' }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
  const text = plainNumber(value, decimals, trim);
  const copy = async (e) => {
    e.stopPropagation();
    await writeClipboard(text);
    setCopied(true);
    toast.success(t('budget.copiedValue', { value: text }));
    setTimeout(() => setCopied(false), 1200);
  };
  const sm = size === 'sm';
  return (
    <button type="button" onClick={copy} title={t('budget.copyValue', { value: text })}
      aria-label={t('budget.copyValue', { value: text })}
      className={`inline-flex ${sm ? 'h-5 w-5 rounded' : 'h-7 w-7 rounded-md'} shrink-0 items-center justify-center align-middle text-gray-400 transition-colors hover:bg-black/5 hover:text-gray-700 ${className}`}
      data-testid={testId}>
      {copied ? <Check className={`${sm ? 'h-3 w-3' : 'h-4 w-4'} text-green-600`} /> : <Copy className={sm ? 'h-3 w-3' : 'h-4 w-4'} />}
    </button>
  );
};

export default CopyNumberButton;
